/**
 * Phone number normalization and validation utilities.
 * Used by alert destinations and SMS-to-channel phone linking.
 */

/** Normalize a phone string to E.164: strip formatting, default to +1 (US). */
export function normalizePhone(phone: string): string {
  // Strip spaces, dashes, parens, dots
  const digits = phone.replace(/[\s\-().]/g, '');
  // If it starts with +, keep as-is
  if (digits.startsWith('+')) return digits;
  // If it starts with 1 and is 11 digits, add +
  if (digits.startsWith('1') && digits.length === 11) return `+${digits}`;
  // 10-digit numbers are assumed US (NANP). Non-US users must include + prefix.
  if (/^\d{10}$/.test(digits)) return `+1${digits}`;
  // Otherwise add + and hope for the best — validation will catch it
  return `+${digits}`;
}

/** Validate E.164 format: + followed by 7–15 digits. */
export function isValidE164(phone: string): boolean {
  return /^\+[1-9]\d{6,14}$/.test(phone);
}
